import React, { createContext, useState } from "react";
import { FaCircleCheck, FaCircleXmark } from 'react-icons/fa6';
import { PiWarningOctagonBold } from 'react-icons/pi';
import "../App.css"


export const FrontendDataContext = createContext();

export const FrontendDataProvider = ({ children }) => {
  // State to hold the frontend data

  const [successAlert, setSuccessAlert] = useState(false);
  const [failAlert, setFailAlert] = useState(false);
  const [warningAlert, setWarningAlert] = useState(false);


  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("")
  const [warningMessage, setWarningMessage] = useState("")


  const [loadingAlert, setLoadingAlert] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false)


  const triggerLoadAlert = (message) => {
    setLoadingAlert(true);
    setLoadingMessage(message);
  }

  const triggerSuccessAlert = (message) => {
    // Show the dropdown
    setFailAlert(false)
    setSuccessMessage(message)
    setSuccessAlert(true);
    // Hide the dropdown after 3 seconds
    const timer = setTimeout(() => {
      setSuccessAlert(false);
      setLoadingAlert(false);
    }, 3000);

    // Cleanup the timer
    return () => clearTimeout(timer);
  }

  const triggerFailAlert = (message) => {
    // Show the dropdown
    setSuccessAlert(false);
    setFailMessage(message);
    setFailAlert(true);
    // Hide the dropdown after 3 seconds


    const timer = setTimeout(() => {
      setLoadingAlert(false)
      setFailAlert(false);
    }, 3000);

    // Cleanup the timer
    return () => clearTimeout(timer);
  }


  const triggerWarning = (message, on) => {
    setLoadingAlert(on);
    setWarningMessage(message);
    setWarningAlert(on)
  }



  // Compile dataObject from state
  const dataObject = {
    successAlert,
    triggerSuccessAlert,
    failAlert,
    triggerFailAlert,
    successMessage,
    failMessage,
    loadingAlert,
    setLoadingAlert,
    loadingMessage,
    triggerLoadAlert,
    warningAlert, setWarningAlert,
    warningMessage, setWarningMessage, triggerWarning
    // ... other states and setters
  };



  return (
    <FrontendDataContext.Provider value={dataObject}>
      {children}
      <div style={{position: "absolute"}}>
          <div className={`loading-indicator ${loadingAlert ? 'show' : ''}`}
          style={{ background: "white", border: (!successAlert && !failAlert && !warningAlert) ? "1px solid rgba(0, 0, 0, 0.1)" : ""}}>


          {!successAlert && !failAlert && !warningAlert ? 
          <div style={{padding: "5px 10px"}}>{`Making changes...`}</div> : 
          <>
          {successAlert && 
            <div style={{display: "flex", alignItems: "center", gap: "10px", padding: "5px 10px", background: "rgba(86, 185, 152, 0.1)", border: "1px solid rgb(86, 185, 152)", borderRadius: "3px" }}>
            {`${successMessage}`}
            <FaCircleCheck style={{ color: "rgb(86, 185, 152)" }} />
            </div>
            }
          
          {failAlert &&
          <div style={{display: "flex", alignItems: "center", gap: "10px", padding: "5px 10px", background: "rgb(203, 77, 72, 0.1)", border: "1px solid rgb(203, 77, 72)", borderRadius: "3px"}}>
              {`${failMessage}`}
                <FaCircleXmark style={{ color: "rgb(203, 77, 72)" }} />
          </div>} 

          {warningAlert &&
          <div style={{display: "flex", alignItems: "center", gap: "10px", padding: "5px 10px", background: "rgb(225, 190, 75, 0.1)", border: "1px solid rgb(225, 190, 75)", borderRadius: "3px"}}>
              {`${warningMessage}`}
                <PiWarningOctagonBold style={{ color: "rgb(225, 190, 75)" }} />
          </div>} 
          </>

        }

        
          </div>
      </div>

    </FrontendDataContext.Provider>
  );
};
